'use client';

import { EcEnv } from '@castlery/config';
// eslint-disable-next-line @nx/enforce-module-boundaries
import { Box, CircularProgress, Stack } from '@castlery/fortress';
// eslint-disable-next-line @nx/enforce-module-boundaries
import { sbApiClient } from '@castlery/modules-cms-components';
import { useEffect, useState } from 'react';
// eslint-disable-next-line @nx/enforce-module-boundaries
import { YotpoScript } from '@castlery/modules-promotion-components';
// eslint-disable-next-line @nx/enforce-module-boundaries
import { SbPage } from '@castlery/modules-cms-components';
import { selectedActiveUser } from '@castlery/modules-user-domain';
import { useAppSelector } from '@castlery/shared-redux-store';
import { BirthdayModal } from './components/birthday-modal';
import { logger } from '@castlery/observability';

async function getStoryblokContent(region: string) {
  const slug = `${region}/general-content-v2/tcc-pages/the-castlery-club${
    EcEnv.NEXT_PUBLIC_APPLICATION_ENV.includes('test') ? '-test' : ''
  }`;
  try {
    const story = await sbApiClient.getStory(slug);
    return story;
  } catch (error) {
    logger.error('Failed to fetch Storyblok content for Castlery Club', {
      error,
      slug,
      region: EcEnv.NEXT_PUBLIC_COUNTRY,
    });
    return null;
  }
}

export function TheCastleryClubPage() {
  const user = useAppSelector(selectedActiveUser);
  const [story, setStory] = useState<any>(null);
  const [loading, setLoading] = useState(true);
  const [yotpoReady, setYotpoReady] = useState(false);
  const region = EcEnv.NEXT_PUBLIC_COUNTRY.toLowerCase();

  useEffect(() => {
    async function fetchStory() {
      setLoading(true);
      const storyData = await getStoryblokContent(region);
      setStory(storyData);
      setLoading(false);
    }

    if (region) {
      fetchStory();
    }
  }, [region]);

  // 等待 Storyblok 内容渲染完成后再加载 Yotpo
  useEffect(() => {
    if (!story || loading) {
      setYotpoReady(false);
      return;
    }

    let isMounted = true;
    let timerId: NodeJS.Timeout;
    let retryCount = 0;
    const MAX_RETRIES = 15; // 最多重试 15 次 (约3秒)

    const checkYotpoContainers = () => {
      if (!isMounted || retryCount >= MAX_RETRIES) return;

      const hasYotpoContainers =
        document.querySelector('[data-yotpo-instance-id]') ||
        document.querySelector('[data-yotpo-widget-id]') ||
        document.querySelector('.yotpo-widget-instance');

      if (hasYotpoContainers) {
        setYotpoReady(true);
      } else {
        retryCount++;
        timerId = setTimeout(checkYotpoContainers, 200);
      }
    };

    // 延迟 300ms 开始检查
    timerId = setTimeout(checkYotpoContainers, 300);

    return () => {
      isMounted = false;
      clearTimeout(timerId);
    };
  }, [story, loading]);

  if (loading) {
    return (
      <Box sx={{ display: 'flex', justifyContent: 'center', p: 4 }}>
        <CircularProgress />
      </Box>
    );
  }

  if (!story) {
    return (
      <Box sx={{ p: 4, textAlign: 'center' }}>
        <p>Unable to load rewards content</p>
      </Box>
    );
  }

  return (
    <>
      <Box
        sx={{
          // px: {
          //   xs: 0,
          //   sm: 0,
          //   md: 0,
          // },
          py: {
            xs: 7,
            md: 8,
          },
          main: {
            margin: '0 !important',
            padding: '0 !important',
            width: '100% !important',
          },
          '& .MuiContainer-root': {
            padding: '0 !important',
          },
        }}
      >
        <Stack>
          <SbPage blok={story.content} />
          <BirthdayModal />
          {/* 等待 Storyblok 内容渲染完成并确认 Yotpo 容器存在后再加载 Yotpo widgets */}
          {EcEnv.NEXT_PUBLIC_YOTPO_ENABLED && yotpoReady && <YotpoScript user={user} />}
        </Stack>
      </Box>
    </>
  );
}
